import { CertificationStatus, OrderMeasuresTypes } from '../../enums';

interface IOrderItemProductSchema {
    name: string;
    code: string;
}

export interface IOrderCertificationSchema {
    type: OrderMeasuresTypes;
    total: string;
    succeeded: string;
}

export interface ItemCertificationSchema {
    id: string;
    product: IOrderItemProductSchema;
    certifications?: IOrderCertificationSchema[];
    subStatus?: string;
}

export interface IOrderMeasureSchema {
    type: OrderMeasuresTypes;
    value: number;
}

export interface IOrderSchema {
    id: string;
    scheduledDate: string;
    trip?: string;
    checkpointIndex?: number;
    code: string;
    qtn?: string;
    items?: ItemCertificationSchema[];
    measures?: IOrderCertificationSchema[];
    status?: CertificationStatus;
    subStatus?: string;
    comment?: string;
}
